/**
 * avatars/presets/avatar-presets-data.js
 * Dữ liệu cấu hình Avatar Presets thuần túy (No DOM/No THREE.js)
 */

import { ALIEN_PRESETS } from '../alien-presets.js';

export const AVATAR_PRESETS = {
  // 1. Thầy giáo STEAM
  TEACHER: {
    id: 'teacher',
    name: 'Thầy giáo STEAM (Dr. Nova)',
    title: 'Giáo viên hướng dẫn',
    scale: 1.05,
    bodyType: 'normal',
    colors: {
      skin: '#fbd0b0',
      hair: '#3b2f2f',
      shirt: '#0284c7',
      pants: '#334155',
      shoes: '#1e293b',
      eyes: '#1e293b'
    },
    features: {
      outfit: 'lab_coat',
      isLabCoat: true,
      hasGlasses: true,
      hairStyle: 'neat_parted',
      heldItem: 'clipboard',
      hasClipboard: true
    },
    defaultReactions: [
      { action: 'cheer', text: 'Tuyệt vời lắm! Em đã hoàn thành xuất sắc bước thí nghiệm này.' },
      { action: 'explain', text: 'Hãy quan sát: khi lực đẩy lớn hơn trọng lực, vật thể sẽ nổi lên mặt nước!' },
      { action: 'think', text: 'Theo em, điều gì sẽ xảy ra nếu ta tăng khối lượng riêng của chất lỏng?' },
      { action: 'wave', text: 'Chào mừng các em đến với phòng thí nghiệm mô phỏng Novastars!' }
    ]
  },

  // 2. Quý cô Áo dài Trắng Việt Nam
  CO_GAI_AO_DAI: {
    id: 'co_gai_ao_dai',
    name: 'Cô gái Áo Dài Trắng',
    title: 'Duyên dáng Việt Nam',
    scale: 0.98,
    bodyType: 'tall_lean',
    gender: 'female',
    colors: {
      skin: '#fde0cb',
      hair: '#171717',
      shirt: '#ffffff', // Áo dài trắng truyền thống
      pants: '#ffffff', // Quần lụa trắng
      shoes: '#ffffff',
      eyes: '#0f766e'
    },
    features: {
      outfit: 'ao_dai',
      hairStyle: 'long_hair',
      hat: 'non_la',
      hasBlush: true
    },
    defaultReactions: [
      { action: 'wave', text: 'Xin chào! Tà áo dài Việt Nam thướt tha trong nắng mai.' },
      { action: 'cheer', text: 'Thật tuyệt vời khi được lan tỏa nét đẹp văn hóa Việt Nam!' },
      { action: 'explain', text: 'Áo dài là quốc phục truyền thống tôn vinh nét đẹp thanh tao của người phụ nữ Việt.' }
    ]
  },

  // 3. Bác Ba Áo Bà Ba Nam Bộ
  BAC_BA_BA: {
    id: 'bac_ba_ba',
    name: 'Bác Ba Nam Bộ',
    title: 'Nông dân hiền hòa',
    scale: 1.0,
    bodyType: 'normal',
    age: 'senior',
    colors: {
      skin: '#e2b395',
      hair: '#262626',
      shirt: '#78350f', // Áo bà ba nâu sồng
      pants: '#1c1917', // Quần đen
      shoes: '#fafaf9', // Dép tổ ong trắng
      eyes: '#171717'
    },
    features: {
      outfit: 'ao_ba_ba',
      hairStyle: 'dan_truong',
      hat: 'non_la',
      bodyAccessory: 'khan_ran',
      heldItem: 'none'
    },
    defaultReactions: [
      { action: 'wave', text: 'Chào bà con cô bác nghen! Khăn rằn vắt vai chuẩn phong cách Nam Bộ!' },
      { action: 'cheer', text: 'Trời ơi đã quá xá đã! Mùa màng năm nay bội thu rồi!' },
      { action: 'think', text: 'Nước nổi năm nay về sớm, để coi thả lưới chỗ nào dính cá linh nhiều...' }
    ]
  },

  // 4. Học sinh Khăn Quàng Đỏ
  HOC_SINH_KHAN_QUANG: {
    id: 'hoc_sinh_khan_quang',
    name: 'Bé Minh (Khăn quàng đỏ)',
    title: 'Đội viên chăm ngoan',
    scale: 0.92,
    bodyType: 'child',
    colors: {
      skin: '#fad4b2',
      hair: '#3f2212',
      shirt: '#ffffff',
      pants: '#1e3a8a',
      shoes: '#ef4444',
      eyes: '#2563eb'
    },
    features: {
      outfit: 'hoc_sinh_vn',
      hairStyle: 'spiky',
      bodyAccessory: 'ba_lo',
      hasBlush: true
    },
    defaultReactions: [
      { action: 'wave', text: 'Em chào thầy cô và các bạn ạ! Sẵn sàng học bài mới rồi!' },
      { action: 'cheer', text: 'Yeah! Em đạt điểm 10 môn Khoa Học Tự Nhiên rồi!' },
      { action: 'think', text: 'Thưa thầy, bài toán cân bằng lực này giải thế nào ạ?' }
    ]
  },

  // 5. Tài xế Grab
  TAI_XE_GRAB: {
    id: 'tai_xe_grab',
    name: 'Anh Tài Xế Grab',
    title: 'Giao hàng công nghệ',
    scale: 1.0,
    bodyType: 'normal',
    colors: {
      skin: '#e5b89a',
      hair: '#27272a',
      shirt: '#00B14F',
      pants: '#18181b',
      shoes: '#ffffff',
      eyes: '#09090b'
    },
    features: {
      outfit: 'grab',
      hat: 'mu_bh_grab',
      mask: 'khau_trang_den',
      bodyAccessory: 'tui_cheo'
    },
    defaultReactions: [
      { action: 'wave', text: 'Dạ Grab tới rồi đây ạ! Đơn hàng của bạn nóng hổi luôn nhé.' },
      { action: 'walk', text: 'Lướt phố Sài Gòn - Hà Nội đón khách thôi nào!' },
      { action: 'cheer', text: 'Cảm ơn bạn đã đánh giá 5 sao cho tài xế!' }
    ]
  },

  // 6. Tài xế Be
  TAI_XE_BE: {
    id: 'tai_xe_be',
    name: 'Bác Tài Be Vàng',
    title: 'Tài xế công nghệ Be',
    scale: 1.0,
    bodyType: 'normal',
    age: 'senior',
    colors: {
      skin: '#dfb091',
      hair: '#18181b',
      shirt: '#facc15',
      pants: '#1e1b4b',
      shoes: '#000000',
      eyes: '#1c1917'
    },
    features: {
      outfit: 'be',
      hat: 'mu_luoi_trai',
      mask: 'khau_trang_trang',
      bodyAccessory: 'tui_cheo'
    },
    defaultReactions: [
      { action: 'wave', text: 'Chào bạn, Be vàng rực rỡ đã có mặt đón bạn đây!' },
      { action: 'cheer', text: 'Đường thông hè thoáng, chuyến đi an toàn tuyệt đối!' }
    ]
  },

  // 7. Tài xế Taxi Xanh SM (VinFast)
  TAI_XE_XANH_SM: {
    id: 'tai_xe_xanh_sm',
    name: 'Bác Tài Xanh SM',
    title: 'Tài xế xe điện VinFast',
    scale: 1.02,
    bodyType: 'normal',
    age: 'senior',
    colors: {
      skin: '#fbd0b0',
      hair: '#27272a',
      shirt: '#06b6d4', // Cyan Xanh SM
      pants: '#0f172a',
      shoes: '#1e293b',
      eyes: '#0e7490'
    },
    features: {
      outfit: 'xanh_sm',
      hairStyle: 'luu_duc_hoa',
      eyewear: 'kinh_can'
    },
    defaultReactions: [
      { action: 'wave', text: 'Xanh SM kính chào quý khách! Xe điện êm ái, không mùi, không tiếng ồn.' },
      { action: 'explain', text: 'Xe điện VinFast giúp giảm thiểu khí thải CO2, bảo vệ môi trường xanh!' },
      { action: 'cheer', text: 'Chúc quý khách có một lộ trình xanh thật thoải mái!' }
    ]
  },

  // 8. Anh chàng Gymer Cơ Bắp
  GYMER_CO_BAP: {
    id: 'gymer_co_bap',
    name: 'Anh Tuấn (Gymer Cơ Bắp)',
    title: 'Vận động viên thể hình',
    scale: 1.08,
    bodyType: 'muscular',
    colors: {
      skin: '#e7ba9c',
      hair: '#111827',
      shirt: '#dc2626',
      pants: '#1f2937',
      shoes: '#f43f5e',
      eyes: '#18181b'
    },
    features: {
      outfit: 'ao_ba_lo',
      shortSleeve: false,
      hasShorts: true,
      hairStyle: 'elvis',
      heldItem: 'dumbbell'
    },
    defaultReactions: [
      { action: 'cheer', text: 'Yeah! Một hiệp đẩy tạ 100kg không thành vấn đề!' },
      { action: 'explain', text: 'Lực cơ học và đòn bẩy đóng vai trò quan trọng trong việc nâng vật nặng.' }
    ]
  },

  // 9. Anh Hùng Bàn Phím
  NERD_DEV: {
    id: 'nerd_dev',
    name: 'Anh Hùng Bàn Phím',
    title: 'Chiến thần gõ phím',
    scale: 0.98,
    bodyType: 'tall_lean',
    colors: {
      skin: '#fed7aa',
      hair: '#3f3f46',
      shirt: '#4f46e5',
      pants: '#312e81',
      shoes: '#ffffff',
      eyes: '#3b82f6'
    },
    features: {
      outfit: 'default',
      hairStyle: 'dan_truong',
      eyewear: 'kinh_nerd',
      heldItem: 'keyboard'
    },
    defaultReactions: [
      { action: 'explain', text: 'Bàn phím cơ gõ 120 WPM, chiến thần bàn phím không ngán ai!' },
      { action: 'think', text: 'Thuật toán tìm đường A* hay Dijkstra sẽ tối ưu hơn cho NPC nhỉ?' },
      { action: 'cheer', text: 'Gõ phím xuyên màn đêm, sáng rực đèn LED RGB!' }
    ]
  },

  // 10. Cô Bán Hàng Rong Phố Cổ
  NGUOI_BAN_HANG_RONG: {
    id: 'nguoi_ban_hang_rong',
    name: 'Cô Bán Hàng Rong',
    title: 'Gánh hàng rong phố cổ',
    scale: 0.96,
    bodyType: 'normal',
    gender: 'female',
    colors: {
      skin: '#dfb091',
      hair: '#171717',
      shirt: '#854d0e', // Áo bà ba nâu đất / nâu sồng
      pants: '#18181b', // Quần lụa đen chấm gót
      shoes: '#fef08a', // Dép tổ ong ngà
      eyes: '#27272a'
    },
    features: {
      outfit: 'ao_ba_ba',
      hairStyle: 'neat_parted',
      hat: 'non_la',
      heldItem: 'ganh_hang_rong'
    },
    defaultReactions: [
      { action: 'wave', text: 'Ai xôi khúc, bánh giò, cốm xanh làng Vòng thơm phức nóng hổi đê!' },
      { action: 'cheer', text: 'Gánh hàng rong đong đầy ký ức tuổi thơ phố phường Hà Nội!' },
      { action: 'walk', text: 'Bươn chải từng góc phố con ngõ mang hương vị quê hương đến mọi nhà.' }
    ]
  },

  // 11. Bác Bán Trà Đá Vỉa Hè Hà Nội
  NGUOI_BAN_TRA_DA: {
    id: 'nguoi_ban_tra_da',
    name: 'Bác Bán Trà Đá',
    title: 'Trà đá vỉa hè Hà Nội',
    scale: 1.0,
    bodyType: 'normal',
    age: 'senior',
    colors: {
      skin: '#e0ab85',
      hair: '#52525b', // Tóc hoa râm
      shirt: '#f8fafc', // Áo ba lỗ trắng
      pants: '#475569', // Quần lửng túi hộp
      shoes: '#facc15', // Dép tổ ong huyền thoại
      eyes: '#18181b'
    },
    features: {
      outfit: 'ao_ba_lo',
      hasShorts: true,
      shortSleeve: false,
      hairStyle: 'spiky',
      hat: 'mu_coi',
      heldItem: 'am_tra_bat_trang'
    },
    defaultReactions: [
      { action: 'wave', text: 'Bàn ghế cóc đây rồi cháu ơi! Làm cốc trà đá mát lạnh, kẹo lạc không?' },
      { action: 'cheer', text: 'Trà đá vỉa hè - nét văn hóa bình dị, thân thương của người Việt Nam!' },
      { action: 'explain', text: 'Ngồi trà đá ngắm phố phường là thú vui tao nhã của người Hà Nội.' }
    ]
  },

  // 12. Anh Shipper Sàn TMĐT
  SHIPPER_SHOPEE: {
    id: 'shipper_shopee',
    name: 'Anh Shipper Sàn TMĐT',
    title: 'Giao hàng hỏa tốc',
    scale: 1.0,
    bodyType: 'normal',
    colors: {
      skin: '#e0ab85',
      hair: '#27272a',
      shirt: '#ea580c',
      pants: '#1e293b',
      shoes: '#ffffff',
      eyes: '#09090b'
    },
    features: {
      outfit: 'shopee',
      hat: 'mu_bh_shopee',
      bodyAccessory: 'thung_hang_shipper',
      heldItem: 'dien_thoai_smartphone',
      mask: 'khau_trang_den'
    },
    defaultReactions: [
      { action: 'check_phone', text: 'Chị ơi ra nhận váy giúp em với, em đứng đợi dưới sảnh chung cư nè!' },
      { action: 'carry_box', text: 'Hôm nay săn sale 25/9 đơn hàng ngập tràn cả thùng xe luôn!' },
      { action: 'wave', text: 'Em gửi bảo vệ tòa nhà nhé, nhớ đánh giá 5 sao cho em nghen!' }
    ]
  },

  // 13. Bác Bảo Vệ Chung Cư
  BAC_BAO_VE: {
    id: 'bac_bao_ve',
    name: 'Bác Bảo Vệ Chung Cư',
    title: 'An ninh trật tự',
    scale: 1.04,
    bodyType: 'normal',
    age: 'senior',
    colors: {
      skin: '#e2b395',
      hair: '#52525b',
      shirt: '#38bdf8',
      pants: '#0f172a',
      shoes: '#18181b',
      eyes: '#0f172a'
    },
    features: {
      outfit: 'bao_ve',
      hat: 'mu_bao_ve',
      bodyAccessory: 'bo_dam_giat_lung',
      heldItem: 'dui_cui_giao_thong'
    },
    defaultReactions: [
      { action: 'traffic_direct', text: 'Xe máy đi chậm bên phải, ô tô bật xi-nhan rẽ hầm B2!' },
      { action: 'hands_behind_back', text: 'Cư dân để xe đúng vị trí vạch kẻ, không chắn lối thoát hiểm!' },
      { action: 'wave', text: 'Chào anh chị tan làm về, nay gió mùa nhớ mặc ấm nhé!' }
    ]
  },

  // 14. Gen Z Văn Phòng Healing
  GENZ_OFFICE: {
    id: 'genz_office',
    name: 'Gen Z Văn Phòng Healing',
    title: 'Deadline & Chữa lành',
    scale: 0.98,
    bodyType: 'normal',
    colors: {
      skin: '#fcd5b5',
      hair: '#1e1b4b',
      shirt: '#1e1b4b',
      pants: '#475569',
      shoes: '#ffffff',
      eyes: '#2563eb'
    },
    features: {
      outfit: 'genz_oversize',
      hairStyle: 'dan_truong',
      bodyAccessory: 'the_nhan_vien',
      heldItem: 'binh_giu_nhiet',
      eyewear: 'kinh_can'
    },
    defaultReactions: [
      { action: 'sip_drink', text: 'Làm một ngụm trà thảo mộc nạp năng lượng tích cực cho cả ngày!' },
      { action: 'check_phone', text: '5h30 rồi, hết giờ làm là tắt Teams đi workshop làm gốm chữa lành!' },
      {
        action: 'think',
        text: 'Hôm nay sao Thủy nghịch hành nên bug này chắc chắn do vũ trụ chứ không phải do mình...'
      }
    ]
  },

  // 15. Bác Cán Bộ Hưu Trí
  CAN_BO_HUU_TRI: {
    id: 'can_bo_huu_tri',
    name: 'Bác Cán Bộ Hưu Trí',
    title: 'Trưởng ban quản trị',
    scale: 1.02,
    bodyType: 'normal',
    age: 'elder',
    colors: {
      skin: '#e2b395',
      hair: '#71717a',
      shirt: '#f1f5f9',
      pants: '#1e293b',
      shoes: '#292524',
      eyes: '#1c1917'
    },
    features: {
      outfit: 'so_mi_can_bo',
      hairStyle: 'neat_parted',
      heldItem: 'none',
      eyewear: 'kinh_can'
    },
    defaultReactions: [
      { action: 'hands_behind_back', text: 'Đề nghị bà con giữ gìn vệ sinh chung, xây dựng nếp sống văn minh đô thị!' },
      { action: 'explain', text: 'Kế hoạch cải tạo cảnh quan sân chơi khu dân cư đã được biểu quyết thông qua.' },
      { action: 'wave', text: 'Chào các cháu thanh niên, buổi sáng chịu khó vận động thể dục thể thao là rất tốt!' }
    ]
  },

  // 16. Bà Chủ Nhà Trọ
  CHU_NHA_TRO: {
    id: 'chu_nha_tro',
    name: 'Bà Chủ Nhà Trọ',
    title: 'Quản lý dãy trọ',
    scale: 0.98,
    bodyType: 'normal',
    gender: 'female',
    age: 'elder',
    colors: {
      skin: '#e5b89a',
      hair: '#94a3b8', // Tóc muối tiêu hơi bạc tự nhiên
      shirt: '#a855f7',
      pants: '#18181b',
      shoes: '#facc15',
      eyes: '#3b0764'
    },
    features: {
      outfit: 'ao_ba_ba',
      hairStyle: 'long_hair',
      bodyAccessory: 'chum_chia_khoa'
    },
    defaultReactions: [
      {
        action: 'taunt',
        text: 'Hôm nay mùng 5 rồi nghen mấy đứa, nhớ chuyển khoản tiền phòng với tiền điện nước nghen!'
      },
      { action: 'wave', text: 'Quê mới gửi lên chục bánh tét với buồng chuối, qua phòng cô mà lấy ăn lấy thảo nè!' },
      { action: 'argue', text: 'Đứa nào dắt xe về khuya đóng cổng cẩn thận, khóa ổ khóa số lại cho cô!' }
    ]
  }
};

// Hợp nhất toàn bộ 30 nhân vật ngoài hành tinh vào AVATAR_PRESETS
Object.assign(AVATAR_PRESETS, ALIEN_PRESETS);
